const sections = [
  { label: "事件归档", href: "#archive" },
  { label: "首发路径追踪", href: "#trace" },
  { label: "平台分布", href: "#platform" },
  { label: "讨论区", href: "#discussion" },
  { label: "归档说明", href: "#notes" },
];

const tracePoints = [
  { label: "最早出现", desc: "以最早可检索的上传时间为准" },
  { label: "首发出处", desc: "标注首发平台与账号线索" },
  { label: "拍摄背景", desc: "场地与活动时间线还原" },
  { label: "泄露链条", desc: "首发、搬运与扩散逐环梳理" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-300 bg-background-200">
      <div className="w-full px-4 py-10 md:px-6 md:py-12">
        <div className="mx-auto w-full max-w-[1220px]">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            <div>
              <div className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                  <i className="ri-fire-line text-lg"></i>
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">黑料照片</span>
              </div>
              <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                专注来源溯源的资讯聚合门户，深挖每张照片的原始来源与首发路径，梳理最早出现在哪个平台、由谁爆出、拍摄背景与泄露链条。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-950">板块导航</h4>
              <ul className="mt-3 space-y-2">
                {sections.map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      className="text-xs text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-950">溯源维度</h4>
              <ul className="mt-3 space-y-2">
                {tracePoints.map((item) => (
                  <li key={item.label} className="text-xs text-foreground-600">
                    <span className="text-foreground-800">{item.label}</span>
                    <span className="mx-1 text-foreground-400">·</span>
                    {item.desc}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-950">内容声明</h4>
              <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                本站仅对已公开传播的内容做来源梳理与时间线归档，不存放原始文件，所有结论均以公开信息与归档快照为准。如涉侵权，可通过讨论区提交更正。
              </p>
            </div>
          </div>

          <div className="mt-8 flex flex-col gap-2 border-t border-background-300 pt-5 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-[11px] text-foreground-500">© 2026 黑料照片 · 来源溯源归档 · 仅供信息整理与围观参考</p>
            <p className="text-[11px] text-foreground-500">最近更新：2026-09-12 12:00</p>
          </div>
        </div>
      </div>
    </footer>
  );
}